import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { MasterDataService } from 'src/app/shared/services/master-data.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']})
export class DashboardComponent {
  powerBIUrl: SafeResourceUrl ;
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 21,
  };

  alert: Alert = {} as Alert;

  constructor(private sanitizer: DomSanitizer, private masterdataService: MasterDataService, private alertService: AlertService) {
    this.powerBIUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      ''
    );
  }
  ngOnInit() {

    this.masterdataService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetMastersById(Data)
          : this.handleError(StatusCode),
      (error) => {
      }
    );
  }

  handleGetMastersById(data: MasterDataDTO[]) {
    this.powerBIUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      data[0].aValue
    );
  }

  handleError(statusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }
}
